module.exports = __webpack_public_path__ + "44963cfc.png";